const DURATION = /^(\d+)(?::([0-5]?\d))?$/;

/**
 * Whole minutes of a length the user typed: `1:30`, `1:3` (1:03) or `2` (two hours). Empty or
 * unreadable input is null.
 */
export const durationTextToMinutes = (text?: string | null): number | null => {
  const match = DURATION.exec(text?.trim() ?? '');
  if (!match) {
    return null;
  }

  const [, hours, minutes = '0'] = match;
  return Number(hours) * 60 + Number(minutes);
};

/** A length in minutes as `H:mm`, such as `8:30`. Empty when there is no length. */
export const formatMinutes = (minutes?: number | null): string => {
  if (minutes === null || minutes === undefined) {
    return '';
  }

  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
};
